import React, { PureComponent, Fragment } from 'react';
import {
  FormGroup,
  Dialog,
  Input,
} from '@tencent/spaui';
import { RPCFactory } from '../../../../utils/RequestUtil';

function SPAUIInputFeedback(props = {}) {
    const {
        count = 0,
        range,
        label,
        as: Tag = '',
        className,
    } = props;

    const CustomTag = Tag || Fragment;

    return (
        <CustomTag>
            {label}
            <span className="spaui-input-feedback-count">{count}</span>
            <span className="spaui-input-feedback-divider">/</span>
            <span className="spaui-input-feedback-range">{range}</span>
        </CustomTag>
    );
};

class SPAUIInputPanel extends PureComponent {
    constructor(props) {
        super(props);
        this.maxWordNumber = props.maxLength;
        this.minWordNumber = props.minLength;
        this.state = {
            value: props.value || '',
            status: props.status || '',
            helpBlock: props.helpBlock || ''
        };
    }

    handleChange = (event, value = '') => {
        const textWithoutSpace = value.replace(/ /g, '');
        const len = textWithoutSpace.length || 0;
        let helpBlock = '',
            status = '';

        if (len < 1) {
            status = 'error';
            helpBlock = '不能为空';
        } if(this.minWordNumber && len < this.minWordNumber) {
            status = 'error';
            helpBlock = `字数少于${this.minWordNumber}`;
        } else if (len > this.maxWordNumber) {
            status = 'error';
            helpBlock = '超过最大字数';
        } else {
            status = '';
            helpBlock = '';
        }
        
        this.setState({
            value,
            status,
            helpBlock
        });
        this.props.updateValueAndValid({ value, valid: status!=='error' });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
          this.setState({ value: this.props.value });
        }
    }
    render() {
        const { value, status, helpBlock } = this.state;
        const { feedback, placeholder, error, className, inputClassName, prefix, } = this.props;        
        const textWithoutSpace = value.replace(/ /g, '');
        return (
            <FormGroup
                feedback={feedback || (this.maxWordNumber ? <SPAUIInputFeedback count={textWithoutSpace.length} range={this.maxWordNumber} /> : null)}
                helpBlock={helpBlock}
                status={status}
                error={error}
                className={className}
                prefix={prefix}
                style={{ width: '450px' }}
            >
                <Input
                    placeholder={placeholder}
                    value={value}
                    onChange={this.handleChange}
                    ref={ el => this.InputRef = el }
                    className={inputClassName}
                    tagType={this.props.tagType || 'input'}
                    style={this.props.tagType==='textarea' ? { height: '200px' } : {}}
                />
            </FormGroup>
        )
    }
} 

class EditDialog extends PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        sceneValid: true,
        contentValid: true,
        usedScene: props.usedScene,
        speechContent: props.speechContent,
      };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.usedScene !== this.props.usedScene) {
          this.setState({ usedScene: this.props.usedScene });
        }
        if (prevProps.speechContent !== this.props.speechContent) {
          this.setState({ speechContent: this.props.speechContent });
        }
    }
    submitEdit = () => {
        const { speechId, setEditDialogShow, setRefresh } = this.props;
        const { usedScene, speechContent } = this.state;
        if(speechId) {
            RPCFactory.call.updateSpeech({ speechId, usedScene, speechContent })
            .done((data) => {
              setEditDialogShow(false);
              setRefresh(true);
            })
            .fail((code, msg) => {
              setEditDialogShow(false);
              alert(msg);
            });
        } else  {
            RPCFactory.call.addSpeech({ usedScene, speechContent })
            .done((data) => {
              setEditDialogShow(false);
              setRefresh(true);
            })
            .fail((code, msg) => {
              setEditDialogShow(false);
              alert(msg);
            });
        }
    }
    updateValueAndValid = (obj) => {
        this.setState(obj);
    }
    render(){
        const props = this.props;
        return (
            <Dialog
                show={props.show}
                type="normal"
                title={props.dialogState=='add' ? '添加话术' : '编辑话术'}
                backdrop
                onSubmit={() => this.submitEdit()}
                onCancel={() => props.setEditDialogShow(false)}
                onClose={() => props.setEditDialogShow(false)}
                style={{ width: '600px', height: '600px' }}
                submitButtonProps={{ disabled: !this.state.sceneValid || !this.state.contentValid }}
            >
                <div className="row" style={{ display: 'flex', marginBottom: '20px' }}>
                    <strong style={{ marginTop: '5px', marginRight: '20px' }}>使用场景</strong>
                    <SPAUIInputPanel
                        placeholder="请输入使用场景"
                        maxLength={20}
                        value={this.state.usedScene}
                        updateValueAndValid={
                            ({value, valid}) => this.updateValueAndValid({
                                'sceneValid': valid,
                                'usedScene': value,
                            })
                        }
                    />
                </div>
                <div className="row" style={{ display: 'flex', marginBottom: '20px' }}>
                    <strong style={{ marginTop: '5px', marginRight: '20px' }}>话术内容</strong>
                    <SPAUIInputPanel
                        placeholder="请输入话术内容, 话术文字150~1500"
                        maxLength={1500}
                        minLength={150}
                        tagType='textarea'
                        value={this.state.speechContent}
                        updateValueAndValid={
                            ({value, valid}) => this.updateValueAndValid({
                                'contentValid': valid,
                                'speechContent': value,
                            })
                        }
                    />
                </div>
            </Dialog>
        ); 
    }
}

export default EditDialog;
